<script lang="ts">
import FicheProjet from '@/generated/fiches/FicheProjet.vue';
import Projet from '@/generated/classes/Projet';
import MetaAttrib from '@/generated/classes/MetaAttrib';
import { storeEtablissement, storePaie } from '@/generated/stores';
import { Extended } from '@/framework/base/classes/Schema';
import { storeContrat } from '@/generated/stores';
import { defineComponent } from "vue";
import { ListFilter, ColumnFilter, ListChoix } from '../classes/ListData';

export default defineComponent({
  components: {},
  extends: FicheProjet,
  data() {
    return {
      lastEtab: 0
    };
  },
  methods: {
    ficheMounted() {
      const filter = new ListFilter();
      const columnFilter = new ColumnFilter();
      const choix = new ListChoix();
      choix.value = this.projet.id;
      columnFilter.name = "projetId";
      columnFilter.staticFilter = true;
      columnFilter.filters.push(choix);
      filter.columnsFilter.push(columnFilter);
      storeContrat.listFilteredContrat(filter);
      storePaie.listFilteredPaie(filter);
      this.onShowSectionChanged();
      this.setFocus();
    },
    projetUpdated(projet: Projet) {
      if (projet.etablissementId != this.lastEtab) {
        this.lastEtab = projet.etablissementId;
      }
    },
    isDisplayed(value: string): boolean {
      if (this.projet.id < 0 && value == 'PROJET') {
        this.setExtended(new Extended('PROJET', this.fiche, true));
      }
      let res = true;
      if (value == 'CONTRAT_LIST') {
        res = this.projet.id > 0;
      }
      if (!this.projet.metaValues && value == 'VALUATE_META_ATTRIB') {
        res = false;
      } else if (this.projet.metaValues && this.projet.metaValues.length == 0 && value == 'VALUATE_META_ATTRIB') {
        res = false;
      }
      return res;
    },
    filterMetaAttrib(metaAttrib: MetaAttrib[]): MetaAttrib[] {
      const etablissement = storeEtablissement.getEtablissement(this.projet.etablissementId);
      return metaAttrib.filter(a => {
        return (
          a.classe == 'PROJET' && a.value != '' &&
          (a.conventionIds.includes(etablissement.conventionId) || a.conventionIds.length == 0)
        )
      });
    }
  }
})

</script>
